import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) { }

  public get(endpoint: string): Observable<any> {
    return this.http.get(endpoint);
  }
  public post(endpoint: string, body: any): Observable<any>  {
    return this.http.post(endpoint, body);
  }
  public put(endpoint: string, body: any): Observable<any>  {
    return this.http.put(endpoint, body);
  }
  public delete(endpoint: string): Observable<any>  {
    return this.http.delete(endpoint);
  }
}
